<template>
  <div class="google-slides-content" :class="{'no-control-box': !_hasControlBox()}">
    <iframe
      class="google-slides-iframe"
      :src="$store.state.slideActive.publishedLink"
      frameborder="0"
      width="997.33"
      height="590"
      allowfullscreen="true"
      mozallowfullscreen="true"
      webkitallowfullscreen="true"
    />
  </div>
</template>
<script>
export default {
  methods: {
    _hasControlBox() {
      const { publishedLink } = this.$store.state.slideActive
      const controlBoxIndex = publishedLink.indexOf('&rm=minimal')
      if (controlBoxIndex !== -1) {
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.google-slides-content {
  height: 590px;
  width: 997.33px;
  &.no-control-box {
    width: 1046.89px;
  }
  .google-slides-iframe {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 768px) and (orientation: landscape) {
    height: 545px;
    width: 917.33px;
    &.no-control-box {
      width: 968.89px;
    }
  }
}
</style>
